module.exports = __webpack_public_path__ + "static/media/Accommodation.291d90e3.svg";